var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hypotheekgevers row"},[_c('div',{staticClass:"col-12"},[_c('tjip-form-group-static-text',{attrs:{"label":"Uw naam"}},_vm._l((_vm.hypotheekgevers),function(h){return _c('div',{key:h},[_vm._v(_vm._s(h))])}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }